import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { buildPersonalProfileRows, buildPersonalProfilePWRows } from './buildPersonalProfile.helper';
import type { CreatePersonalProfileHandler } from './types';
import { useLayout } from '../../../providers/Layout.provider';

const { Box, Button, Term, ElementContainer, TextField, Checkbox } = vp;

type PersonalProfileFormProps = {
  defaultValues: vp.IQ11PersonalProfile;
  handlers: CreatePersonalProfileHandler;
};

type FC = FunctionComponent<PersonalProfileFormProps>;

const PersonalProfileForm: FC = (props: PersonalProfileFormProps) => {
  const { defaultValues, handlers } = props;
  const { color } = useLayout();
  const PersonalProfileRow = buildPersonalProfileRows();
  const PersonalProfilePWRows = buildPersonalProfilePWRows();

  return (
    <Formik initialValues={defaultValues} onSubmit={handlers.onCreatePersonalProfile}>
      {({ touched, errors, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          {PersonalProfileRow.map(({ label, id, required, preset }) => (
            <ElementContainer
              key={id}
              label={label}
              required={required}
              color="black"
              input={
                <TextField
                  name={id}
                  variant="background"
                  preset={preset}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={errors[id] && touched[id] ? errors[id] : null}
                />
              }
            />
          ))}

          <Box gap="sm" width="100%" jc="sb">
            {PersonalProfilePWRows.map(({ label, id, required, preset }) => (
              <Box key={id} flx="col" width="49%">
                <ElementContainer
                  label={label}
                  required={required}
                  color="black"
                  input={
                    <TextField
                      name={id}
                      variant="background"
                      preset={preset}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={errors[id] && touched[id] ? errors[id] : null}
                    />
                  }
                />
              </Box>
            ))}
          </Box>

          <Box pt="md" jc="fs">
            <div style={{ marginLeft: -30 }}>
              <Checkbox
                name="personal-profile-check"
                value={false}
                variant="rounded"
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </div>
            <Term
              term={
                <div>
                  By creating an account, you agreed to the <a>terms of service and conditions</a>, and{' '}
                  <a>privacy policy</a>
                </div>
              }
            />
          </Box>

          <Box mt="md" height="auto">
            <Link to={{ pathname: '/connect/bank' }} style={{ width: '100%' }}>
              <Button
                id="personal-profile"
                label="Create Profile"
                type="submit"
                background={color}
                textColor={vp.getContrastColor(color)}
                width="100%"
                size="xlg"
                round
                bold
                noShadow
                textSize={1}
              />
            </Link>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default PersonalProfileForm;
